import { getSidebarCustomize, ready, conditionalControls, customControl, addContentBesideSection, makeDefaultsResettable, initializeTinyMce } from ".";
import { CssMarginInput, Headline, CustomHTML, RangeInput } from "../components";
/**
 * A factory functionality which provides different implementations especially
 * for the "sidebar" use case. Also, it predefine some controls.
 */ function sidebarFactory(param) {
    let { panel, ids, defaults, onReady, conditionals, controls, contentBesideSection } = param;
    ready((customize)=>{
        // Only run the factory if panel exists
        if (!getSidebarCustomize().panel(panel)) {
            return;
        }
        conditionals && conditionalControls(panel, conditionals);
        contentBesideSection && addContentBesideSection(contentBesideSection);
        makeDefaultsResettable(ids, defaults);
        initializeTinyMce();
        onReady(customize);
    });
    controls && customControl(controls);
    // Predefine components
    customControl({
        cssMargin: CssMarginInput,
        rangeInput: RangeInput,
        headline: Headline,
        customHtml: CustomHTML
    });
    return true;
}
export { sidebarFactory };
